import { c as _c } from "react/compiler-runtime";
import { fetcher } from "@website/fetcher/fetcher";
import { useFetcherV2 } from "@website/fetcher/use-fetcherV2";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { GetBalanceMutationKey, GetBalanceResponseTypes } from "./types";
export const getBalanceApiURL = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/wallet/v1/users/balance`;
export const useGetBalance = () => {
  const $ = _c(9);
  const {
    isLoggedIn
  } = useLoginStatus();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [GetBalanceMutationKey];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isLoggedIn) {
    t1 = {
      queryKey: t0,
      queryFn: _temp2,
      enabled: isLoggedIn
    };
    $[1] = isLoggedIn;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: data_0,
    isLoading,
    error
  } = useFetcherV2(t1);
  let t2;
  if ($[3] !== data_0) {
    t2 = data_0 || {
      balance: 0,
      creditLimit: 0,
      ledgerBalance: 0
    };
    $[3] = data_0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== error || $[6] !== isLoading || $[7] !== t2) {
    t3 = {
      isLoadingGetBalance: isLoading,
      balance: t2,
      isBalanceError: error
    };
    $[5] = error;
    $[6] = isLoading;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
function _temp(t0) {
  const {
    data
  } = t0;
  return data as GetBalanceResponseTypes;
}
function _temp2() {
  return fetcher({
    url: getBalanceApiURL
  }).then(_temp);
}